<template>
  <div>
    <div class="row" v-if="quiz">
      <div class="col-lg-12">
          <div class="mt-element-step">

            <div class="row step-background-thin">
                <div class="col-md-4 bg-grey-steel mt-step-col pointer" :class="{'active':show.quiz, 'disabled': quiz.state == 'published'}" v-on:click="goStep('quiz')">
                    <div class="mt-step-number">1</div>
                    <div class="mt-step-title uppercase font-grey-cascade">Questionnaire</div>
                    <div class="mt-step-content font-grey-cascade">Configuration des paramètres du questionnaire</div>
                </div>
                <div class="col-md-4 bg-grey-steel mt-step-col pointer" :class="{'active':show.questions, 'disabled':!quiz.slug || quiz.state == 'published'}" v-on:click="goStep('questions')">
                    <div class="mt-step-number">2</div>
                    <div class="mt-step-title uppercase font-grey-cascade">Questions</div>
                    <div class="mt-step-content font-grey-cascade">Configuration des questions</div>
                </div>
                <div class="col-md-4 bg-grey-steel mt-step-col pointer" :class="{'active':show.share, 'disabled':!quiz.slug || quiz.questions.length <= 0 || quiz.state == 'published'}" v-on:click="goStep('share')">
                    <div class="mt-step-number">3</div>
                    <div class="mt-step-title uppercase font-grey-cascade">Partage</div>
                    <div class="mt-step-content font-grey-cascade">Envoyer votre formulaire aux participants</div>
                </div>
              </div>
          </div>

          <div class="portlet light portlet-fit portlet-form bordered col-xs-12 p-0">
              <div class="portlet-body col-xs-12 mt-30">

                  <div class="col-xs-12"><h4>Etat : <div v-html="getState" style="display:inline"></div></h4></div>
                  <!-- QUESTIONNAIRE CONFIG -->
                  <create-quiz ref="create" :quiz.sync="quiz" v-if="show.quiz"></create-quiz>
                  <!-- END QUESTIONNAIRE CONFIG -->
                  <!-- QUESTIONS CONFIG -->
                  <create-questions ref="questions" :quiz.sync="quiz" :show.sync="show" v-if="show.questions"></create-questions>
                  <!-- END QUESTIONS CONFIG -->
                  <!-- PARTAGE -->
                  <share-quiz :quiz.sync="quiz" v-if="show.share"></share-quiz>
                  <!-- END PARTAGE -->

                  <!-- BOUTONS  -->
                  <div class="col-xs-12">
                    <div class="form-actions col-xs-12">
                        <div class="row">
                            <div class="text-left" style="float:left;">
                              <a v-on:click="$router.back()" class="btn default">Annuler</a>
                              <a v-if="!show.quiz && quiz.state != 'published'" v-on:click="show.share ? goStep('questions') : goStep('quiz')" class="btn default">Précédent</a>
                            </div>
                            <div class="text-right">
                                <a v-if="quiz.questions && quiz.questions.length > 0 && quiz.state != 'published'" v-on:click="saveQuiz(false,'published')" class="btn green">Publier</a>
                                <!-- <a v-if="quiz.state == 'published'" v-on:click="saveQuiz(false,'draft')" class="btn red">Annuler publication</a> -->
                                <a v-if="!show.share" v-on:click="saveQuiz(true)" class="btn default">Enregistrer & Quitter</a>
                                <a v-if="!show.share" v-on:click="saveQuiz(false)" class="btn green">Enregistrer</a>
                                <router-link v-if="show.share" :to="{name:'quizzes_list'}" class="btn btn default">Quitter</router-link>
                            </div>
                        </div>
                    </div>
                  </div>
                  <!-- END BOUTONS  -->

              </div>
          </div>

      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12 page-404">
          <div class="number font-green"> 404 </div>
          <div class="details">
              <h3>Oops ! Questionnaire non trouvé.</h3>
              <p> Nous n'avons pas réussi à trouver ce questionnaire.
                  <br>
                  <router-link :to="{name:'quizzes_list'}"> Retourner à la liste des questionnaires </router-link> ou essayer de recharger la page.
              </p>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

import quizzes from '../../requests/quizzes.js'
import CreateQuestions from './create_questions'
import CreateQuiz from './create_quiz'
import ShareQuiz from './share_quiz'

export default {
  name: 'quizzes_create',
  components: {
    CreateQuestions,
    CreateQuiz,
    ShareQuiz
  },
  data() {
    return{
      show:{
        quiz:true,
        questions:false,
        share:false
      },
      quiz:{}
    }
  },
  mounted:function(){
    this.init();
  },
  watch:{
    'show.quiz':function(){
      if(this.show.quiz){
        this.show.questions = false;
        this.show.share = false;
      }
    },
    'show.questions':function(){
      if(this.show.questions){
        this.show.quiz = false;
        this.show.share = false;
      }
    },
    'show.share':function(){
      if(this.show.share){
        this.show.quiz = false;
        this.show.questions = false;
      }
    },
    '$route':function(to, from) {
      if(from.name == "quizzes_create" && to.name == "quizzes_edit"){
        this.init();
      }
    }
  },
  computed:{
    getState(){
      var state = "";
      switch(this.quiz.state){
        case "draft":
          state = '<span class="label label-sm label-warning"> Brouillon </span>';
        break;
        case "published":
          state = '<span class="label label-sm label-success"> Publié </span>';
        break;
      }
      return state;
    }
  },
  methods:{
    init(){
      this.reinit();
      var parent = this;
      this.$nextTick(function () {
        if(this.$route.params && this.$route.params.slug){
          //Récupérer le questionnaire à éditer.
          quizzes.getBySlug(this,this.$route.params.slug,function(quiz,err){
            if(!quiz){
              toastr.error("Impossible de récupérer le questionnaire.","ERREUR");
              parent.quiz = null;
            }else{
              parent.quiz = quiz;
              parent.quiz["questions"] = [];
              if(quiz.date_deadline){
                $("#date_deadline").datepicker("setDate",new Date(quiz.date_deadline));
              }

              // Récupérer les questions du questionnaire.
              quizzes.getQuestions(parent,parent.$route.params.slug,function(questions,err){
                if(questions){
                  parent.quiz['questions'] = questions;
                  if(parent.quiz.state == 'published'){
                    parent.goStep('share');
                  }
                  if(parent.$route.query && parent.$route.query.show && parent.$route.query.show == "questions"){
                    parent.goStep('questions');
                  }
                  parent.$forceUpdate(); // permet l'update des classes des onglets en haut.
                }
                else{
                  toastr.error("Impossible de récupérer les questions du questionnaire.","ERREUR");
                }
              })


            }
          })
        }
      })
    },
    forceUpdate(){
      this.$forceUpdate();
    },
    reinit(){
      this.quiz = {
        title:"",
        date_deadline:"",
        instructions:"",
        conclusion:"",
        state:"draft",
        groups:[{
          name:"",
          nb_participants:0
        }],
        company:{
          name:""
        },
        questions:[]
      };

      this.show.quiz = true;

      this.$forceUpdate();
    },
    goStep(step_name){
      switch(step_name){
        case 'quiz':
          if(this.quiz.state != 'published'){
            this.show.quiz = true;
          }
        break;
        case 'questions':
          if(this.quiz.slug && this.quiz.state != 'published'){
            this.show.questions = true
          }
        break;
        case 'share':
          if(this.quiz.slug && this.quiz.questions.length > 0){
            this.show.share = true;
          }
        break;
      }
    },
    saveQuiz(exit,state){
      if(this.quiz.slug){
        // Alors UPDATE.
        if(this.show.quiz){
          if(state){
            this.quiz.state = state;
          }
          this.updateQuiz(exit);
        }
        else if(this.show.questions){
          if(state){
            // Si le status a été MAJ faut update le QUIZ;
            this.updateStateQuiz(state);
          }
          this.$refs.questions.saveQuestions(exit);
        }
        else if(this.show.share && state){
          this.updateStateQuiz(state);
        }
      }
      else{
        if(state){
          this.quiz.state = state;
        }
        // Create
        this.createQuiz(exit);
      }
    },
    createQuiz(exit){
      var parent = this;
      $('#form_quiz_create').parsley().validate()
      if($("#form_quiz_create").parsley().isValid()){
        this.quiz.date_deadline = $("#date_deadline").datepicker("getDate");
        quizzes.create(this,this.quiz,function(quiz,err){
          if(quiz){
            parent.quiz = quiz;
            parent.quiz["questions"] = [];

            if(quiz.date_deadline){
              $("#date_deadline").datepicker("setDate",new Date(quiz.date_deadline));
            }
            toastr.closeButton = true;
            toastr.success("Le questionnaire a été enregistré.");
            if(exit){
              parent.$router.push({name:"quizzes_list"});
            }else{
              parent.$router.push({name:"quizzes_edit",params:{slug:parent.quiz.slug},query:{show:"questions"}});
            }

            parent.$forceUpdate();
          }
          else{
            toastr.error(err,"ERREUR");
          }
        })
      }
    },
    updateQuiz(exit){
      var parent = this;
      $('#form_quiz_create').parsley().validate()
      if($("#form_quiz_create").parsley().isValid()){
        this.quiz.date_deadline = $("#date_deadline").datepicker("getDate");
        quizzes.updateBySlug(this,this.quiz.slug,this.quiz,function(quiz,err){
          if(quiz){
            toastr.success("Le questionnaire a été enregistré.");
            if(exit){
              parent.$router.push({name:"quizzes_list"});
            }
            if(parent.show.quiz){
              parent.show.questions = true;
            }
          }
          else{
            toastr.error(err,"ERREUR");
          }
        })
      }
    },
    updateStateQuiz(state){
      var parent = this;
      // Si changement de state.
      if(this.quiz.state != state){
        this.quiz.state = state;
        quizzes.updateBySlug(this,this.quiz.slug,this.quiz,function(quiz,err){
          if(quiz){
            parent.quiz.groups = quiz.groups;
            toastr.options.closeButton = true;
            toastr.success("Le questionnaire a été enregistré.");
          }
          else{
            toastr.options.closeButton = true;
            toastr.error(err,"ERREUR");
          }
        })
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.

    // Réinit le quiz si on est sur la route quizzes_edit et qu'on click sur quizzes_create.
    this.reinit();
    next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mt-step-number{
    top:1px;
  }
</style>



// WEBPACK FOOTER //
// create.vue?50e29337